"use client"

import styled from "@emotion/styled"
import { CheckNewIcon, NewText } from "ui"
import { Apartment } from "utils"

const SpecsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 40px;
  }
`

const TopSpecs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
    flex-direction: row;
    gap: 120px;
  }
`
const BodyHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 16px;
  }
  .swiper-wrapper {
    margin-bottom: 2rem;
  }
  .swiper-pagination {
    bottom: 0;
    width: max-content;
    left: auto;
    right: auto;
    inset-inline-start: 0;
    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      cursor: pointer;
      padding: 0;
      background-color: transparent;
      border-radius: 200px;
      border: 1px solid #000000;
    }
    .swiper-pagination-bullet-active {
      background: black;
    }
  }
`

const CharGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  ${(props) => props.theme.breakpoints.up("md")} {
    column-gap: 37.5px;
    grid-template-columns: repeat(3, 1fr);
  }
`

const StyledBuildingCharacteristicsText = styled(NewText)`
  * {
    &:first-child {
      margin-top: 0 !important;
    }
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
`

const Char = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 38px;
`
type Props = {
  apartment: Apartment
  buildingCharacteristicsText?: string
}
function BuildingFeatures({ apartment, buildingCharacteristicsText }: Props) {
  return (
    <SpecsContainer>
      <TopSpecs>
        <BodyHeader>
          {buildingCharacteristicsText && (
            <StyledBuildingCharacteristicsText
              component={"div"}
              desktopFontSize={16}
              color={"#011727"}
              desktopLineHeight={"22px"}
              mobileFontSize={16}
              mobileFontWeight={400}
              desktopFontWeight={300}
              mobileLineHeight={"22px"}
              dangerouslySetInnerHTML={{
                __html: buildingCharacteristicsText,
              }}
            />
          )}
          <CharGrid>
            {apartment.buildingCharacteristics.map((el, i) => (
              <Char key={i}>
                <div>
                  <CheckNewIcon />
                </div>
                <NewText
                  component={"span"}
                  desktopFontSize={16}
                  color={"#011727"}
                  desktopLineHeight={"22px"}
                  mobileFontSize={16}
                  mobileFontWeight={400}
                  desktopFontWeight={300}
                  mobileLineHeight={"22px"}
                >
                  {el}
                </NewText>
              </Char>
            ))}
          </CharGrid>
        </BodyHeader>
      </TopSpecs>
    </SpecsContainer>
  )
}
export default BuildingFeatures
